module.exports = __webpack_public_path__ + "img/TIMEDOTSMALL.092ec674.png";